(function() {
    'use strict';
    angular.module('wbDashboard').directive('wbSticky', ['$state', '$window', '$timeout', function ($state, $window, $timeout) {
        /**
         * This directive is to emulate the bootstrap affix plugin or the newer position: sticky css
         *
         * Optional attributes:
         * @param {int} offset-top - if fromTop: distance from top of window to start sticking
         *                         - if from bottom: distance from top of parent when coming into view from bottom to start from
         * @param {int} offset-bottom - distance to stop before end anchor
         * @param {int} min-width - disable if smaller than this
         * @param {int} max-width - disable if greater than this
         * @param {bool} anchor-bottom - if true will stick to bottom
         * @param {string} sticky-parent - jquery selector for parent attachment
         * @param {bool} use-fixed-scrolling - set element to fixed when scrolling
         * @param {bool} use-parents-bottom - if parent bottom is lower than element bottom, still use parent
         */
        return {
            restrict: 'A',
            link: function ($scope, $elem, $attrs) {
                var options, distance,
                    $parent = null,
                    $directParent = null,
                    $wrapper = null,
                    currentClass = null,
                    refresh = false;


                /**
                 * options.useCurrentAdjustment
                 * extra option, not sure if better or not
                 * if it's not used, it's always recalculated from scratch
                 * in the case something gets out of whack
                 * but could cause some flickering
                 * @type {boolean}
                 */
                options = {
                    anchorBottom: $attrs.anchorBottom || false,
                    stickyParent: $attrs.stickyParent || null,
                    minWidth: $attrs.minWidth || null,
                    maxWidth: $attrs.maxWidth || null,
                    fixedScrolling: $attrs.useFixedScrolling || false,
                    parentTop: $attrs.useParentTop || false,
                    parentBottom: $attrs.useParentBottom || false,
                    marginTop: $attrs.useMarginTop || false,
                    useCurrentAdjustment: false,
                    classBefore: "",
                    classScrolling: "",
                    classAfter: ""
                };

                distance = {
                    extraTopSpace: $attrs.offsetTop*1 || $attrs.offset*1 || 0,
                    extraBottomSpace: $attrs.offsetBottom*1 || 0,
                    currentAdjustment: 0,
                    scrolled: 0,
                    elemFull: null,
                    elemBase: null
                };

                $elem = angular.element($elem);

                $directParent = $elem.parent();
                if (options.stickyParent) {
                    $parent = $elem.closest(options.stickyParent);
                    if (!$parent.length) {
                        $parent = angular.element(options.stickyParent).first();
                        if (!$parent.length) {
                            console.log('WB Sticky couldn\'t find any element matching "'+options.stickyParent+'". Using direct parent instead.');
                        }
                    }
                }
                if (!$parent || !$parent.length) {
                    $parent = $directParent;
                }

                //keep space for element in case position fixed is used
                $wrapper = $elem.wrap("<div class='wb-sticky-wrapper'></div>").parent();



                //will keep elements margin matching the amount scrolled down so it appears to stay still
                function updateAdjustment() {
                    var newAdjustment, elemNewTop, elemNewBottom, originalTransform, statusClass, screenWidth;

                    // If fixed: maintain width to parent and maintain original locations height
                    // to be able to maintain width of fixed element to parent even though it's fixed
                    //and to maintain original locations height if it's 
                    $elem.get(0).style.setProperty('--attached-parent-width', $parent.innerWidth()+'px');
                    $elem.get(0).style.setProperty('--direct-parent-width', $directParent.innerWidth()+'px');
                    $wrapper.css('min-height',$elem.outerHeight(true));

                    screenWidth = angular.element($window).width();
                    if (   options.minWidth && screenWidth < option.minWidth
                        || options.maxWidth && screenWidth > option.maxWidth) {
                        //don't do anything
                        $elem.css('transform', '');
                        $elem.css('margin-top','');
                        $elem.css('position', '');
                        distance.currentOffset = 0;
                        return;
                    }


                    if (!options.useCurrentAdjustment) {
                        //if using not current offset, then elemFull & elemBase are the same
                        //so must clear this so they'll match or there won't be any adjustment
                        if (!options.marginTop) {
                            $elem.css('transform', '');
                        } else {
                            $elem.css('margin-top','');
                        }
                    }

                    var elemFixed = $elem.css('position').indexOf('fixed') > -1;

                    if (!options.anchorBottom) {
                        if (elemFixed) {
                            $elem.css('top', 0);
                        } else {
                            $elem.css('top', '');
                        }
                    } else {
                        //not necessary
                        //works with or without, finicky either way in different cases
                        if (elemFixed) {
                            // $elem.css('bottom', 0);
                        } else {
                            // $elem.css('bottom', '');
                        }
                    }

                    
//rename elemFull to elemFullTopPosition
//rename elemBase to elemRootTop
//and elemRootBottom
                    distance.scrolled = angular.element($window).scrollTop();
                    distance.elemFull = $elem.offset().top;
                    distance.elemBase = distance.elemFull - distance.currentAdjustment;

                    //parentTop is different if stickied to top or bottom
                    //since the extraTopSpace is from the top of the page on stickied top
                    //and top of the parent on stickied bottom
                    var parentTop = $parent.offset().top + parseInt($parent.css('padding-top'));

                    //bottom is treated the same in either case so may include extraBottomSpace
                    var parentBottom = $parent.offset().top + $parent.outerHeight() - parseInt($parent.css('padding-bottom')) - distance.extraBottomSpace;

                    var elemBottom = distance.elemBase + $elem.outerHeight();

                    if (!options.anchorBottom) {
                        //stick to top by default

                        //offset from top once scrolled down to
                        if (distance.elemBase < distance.scrolled + distance.extraTopSpace) {

                            //adjustment to place element in off set location regardless of page position
                            newAdjustment = distance.scrolled - distance.elemBase + distance.extraTopSpace;
                            elemNewTop = distance.elemBase + newAdjustment;
                            elemNewBottom = elemNewTop + $elem.outerHeight();

                            if (elemNewBottom > parentBottom) {
                                //bottom of element is below parent, no bueno

                                newAdjustment = parentBottom - elemBottom;
                                statusClass = "wb-sticky-after";

                            } else if (elemNewTop < parentTop) {
                                //top of element is above parent, no bueno
                                //this case is possible if position is fixed
                                newAdjustment = 0;
                                statusClass = "wb-sticky-before";
                            } else {
                                //inside sticky area
                                if (elemFixed) {
                                    // $elem.css('top', distance.extraTopSpace);
                                }
                                statusClass = "wb-sticky-scrolling";
                            }

                        } else {
                            newAdjustment = 0;
                            statusClass = "wb-sticky-before";
                        }

                    } else {
                        //stick to bottom only if set

                        //adjust parent top since for bottom sticky to treat it like it includes the extra top space
                        parentTop = parentTop + distance.extraTopSpace;

                        // this case is taken care of with $wrapper
                        // if ($elem.outerHeight(true) > $directParent.height()) {
                            // parentBottom += $elem.outerHeight() - $directParent.height();
                        // }

                        //ensure it doesn't go lower than it's default static position
                        var wrapperBottom = $wrapper.offset().top + $wrapper.outerHeight() - distance.extraBottomSpace;
                        if (!options.parentBottom && wrapperBottom < parentBottom) {
                           parentBottom = wrapperBottom;
                        }


                        var viewHeight = angular.element($window).height();
                        var elemHeight = $elem.outerHeight();
                        var screenBottom = distance.scrolled + viewHeight;

                        if (parentTop < screenBottom) {
                            //parent is now above screen bottom
                            newAdjustment = parentTop - distance.elemBase;
                            statusClass = "wb-sticky-peaking";
                            if (screenBottom - parentTop > elemHeight) {

                                if (parentBottom > screenBottom) {
                                    newAdjustment = screenBottom - distance.elemBase - elemHeight;
                                    statusClass = "wb-sticky-scrolling";
                                } else {
                                    newAdjustment = parentBottom - distance.elemBase - elemHeight;
                                    statusClass = "wb-sticky-after";
                                }
                            //     elemNewBottom = distance.elemBase + $elem.outerHeight() + newAdjustment;
                            //     if (newAdjustment > 0) {
                            //         newAdjustment = 0;
                            //         statusClass = "wb-sticky-after";
                            //     } else if (elemNewBottom + distance.extraBottomSpace > parentBottom) {
                            //         newAdjustment = parentBottom - distance.elemBase - elemHeight;
                            //         statusClass = "wb-sticky-after";
                            //     } else {
                            //         statusClass = "wb-sticky-scrolling";
                            //     }
                            }
                        } else {
                            newAdjustment = 0;
                            statusClass = "wb-sticky-before";
                        }
                    }

                    //just get every time in case there's a percentage used in a transform
                    //since percentages aren't reflected in the returned matrix
                    originalTransform = $elem.css('transform','').css('transform') + " ";
                    if (originalTransform === "none ") {
                        originalTransform = "";
                    }

                    if (!options.marginTop) {
                        $elem.css('transform', originalTransform + ' translateY(' + newAdjustment + 'px)');
                    } else {
                        $elem.css('marginTop', newAdjustment);
                    }

                    if (options.useCurrentAdjustment) {
                        distance.currentAdjustment = newAdjustment;
                    }


                    //if the class changes, the offset might change with new css
                    //only want to run one extra time to prevent infinite loop
                    refresh = !refresh && currentClass !== statusClass;

                    if (statusClass==="wb-sticky-scrolling" && options.fixedScrolling) {
                        $elem.css('position', 'fixed');
                    } else {
                        $elem.css('position', '');
                    }

                    $elem.removeClass(function (index, className) {
                        return (className.match (/(^|\s)wb-sticky-\S+/g) || []).join(' ');
                    }).addClass(statusClass);
                    currentClass = statusClass;

                    if (refresh) {
                        refresh = "currently";
                        updateAdjustment();
                    }
                }


                /************************************************
                 ****** ALL CASES WHERE UPDATE IS REQUIRED ******
                 ************************************************/

                $timeout(function() {
                    updateAdjustment();
                }, 100);

                $scope.$watch(function() { return angular.element($window.document).height(); }, function (h) {
                    updateAdjustment();
                });
                angular.element($window).on('resize', updateAdjustment);
                angular.element($window).on('scroll', updateAdjustment);

                $scope.$on('$destroy', function () {
                    angular.element($window).off('scroll', updateAdjustment);
                    angular.element($window).off('resize', updateAdjustment);
                });

            }
        };
    }]);
})();
